import {
  Search,
  X,
} from "lucide-react";

const SearchBox = ({
  value = "",
  onChange,
  placeholder =
    "Search...",
  className = "",
}) => {
  return (
    <div
      className={`app-search-box ${className}`}
    >
      <Search
        size={18}
        className="app-search-icon"
      />

      <input
        type="search"
        value={value}
        placeholder={
          placeholder
        }
        onChange={(event) =>
          onChange?.(
            event.target.value
          )
        }
      />

      {value && (
        <button
          type="button"
          className="app-search-clear"
          onClick={() =>
            onChange?.("")
          }
          aria-label="Clear search"
        >
          <X size={17} />
        </button>
      )}
    </div>
  );
};

export default SearchBox;